<div class="payment-container">
  <h2>Checkout</h2>
  
  <!-- Stripe will inject the card input field here -->
  <div id="card-element" class="card-element"></div>

  <button (click)="createPayment()">Pay $50</button>
</div>